import {
	GET_EMAIL_GROUPS,
	GET_EMAIL_AGENTS,
	SEND_EMAIL_ASSIGNMENT_RULES,
	GET_ALL_EMAIL_ASSIGNMENT_RULES,
	UPDATE_EMAIL_ASSIGNMENT_RULES,
	DELETE_EMAIL_ASSIGNMENT_RULE,
	UPDATE_EMAIL_ASSIGNMENT_RULE_STATUS,
} from "../constants/EmailAssignment";

import {
	saveEmailAgents,
	saveEmailGroups,
	saveAllEmailAssignmentRules,
	getAllEmailAssignmentRules,
} from "../actions/EmailAssignment";
import { all, put, takeEvery } from "redux-saga/effects";
import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";

function* getEmailAgents() {
	yield takeEvery(GET_EMAIL_AGENTS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/bot-agents");
			if (res && res.status == "success") {
				yield put(saveEmailAgents(res.data));
			}
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* getEmailGroups() {
	yield takeEvery(GET_EMAIL_GROUPS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/user-teams-inbox");

			if (res && res.status == "success") {
				yield put(saveEmailGroups(res.data));
			}
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* sendEmailAssignmentRules() {
	yield takeEvery(SEND_EMAIL_ASSIGNMENT_RULES, function* (action) {
		try {
			yield ApiService.post("/hulk/api/v1/lead-emails", {}, action.payload);

			yield put(getAllEmailAssignmentRules());

			toastNotification({ successMessage: "Rule created successfully" });
		} catch (error) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* updateEmailAssignmentRules() {
	yield takeEvery(UPDATE_EMAIL_ASSIGNMENT_RULES, function* (action) {
		const { id: chatAssignmentId, rules: chatAssignmentRules } = action.payload;
		console.log("updateChatAssignmentRules", action.payload);

		try {
			yield ApiService.put(`/hulk/api/v1/lead-emails/${chatAssignmentId}`, {}, chatAssignmentRules);

			yield put(getAllEmailAssignmentRules());

			toastNotification({ successMessage: "Rule updated successfully" });
		} catch (error) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* updateEmailAssignmentRuleStatus() {
	yield takeEvery(UPDATE_EMAIL_ASSIGNMENT_RULE_STATUS, function* (action) {
		const { id: chatAssignmentId, rules: chatAssignmentRules } = action.payload;

		try {
			yield ApiService.put(`/hulk/api/v1/lead-emails/${chatAssignmentId}`, {}, chatAssignmentRules);

			yield put(getAllEmailAssignmentRules());

			toastNotification({
				successMessage: "Rule status updated successfully",
			});
		} catch (error) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* getAllEmailAssignmentRulesSaga() {
	yield takeEvery(GET_ALL_EMAIL_ASSIGNMENT_RULES, function* (action) {
		try {
			const res = yield ApiService.get(`/hulk/api/v1/lead-emails`, {}, {});

			yield put(saveAllEmailAssignmentRules(res.data));
		} catch (error) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

function* deleteEmailAssignmentRule() {
	yield takeEvery(DELETE_EMAIL_ASSIGNMENT_RULE, function* (action) {
		try {
			yield ApiService.delete(`/hulk/api/v1/lead-emails/${action.payload}`);

			yield put(getAllEmailAssignmentRules());

			toastNotification({ successMessage: "Rule deleted successfully" });
		} catch (error) {
			toastNotification({ errorMessage: "Internal Server Error" });
		}
	});
}

export default function* rootSaga() {
	yield all([
		getEmailAgents(),
		getEmailGroups(),
		sendEmailAssignmentRules(),
		getAllEmailAssignmentRulesSaga(),
		updateEmailAssignmentRules(),
		deleteEmailAssignmentRule(),
		updateEmailAssignmentRuleStatus(),
	]);
}
